import React, { useEffect } from 'react';
import './LandingPages.css'
import { FaPlus } from "react-icons/fa";
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import LandingModal from './LandingModal/LandingModal';
import { liveServerUrl, serverUrl } from '../../../Shared/constant';



const LandingPages = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [landingPages, setLandingPages] = useState([])


  useEffect(() => {
    fetch(`${liveServerUrl}/api/landingPages`)
      .then((response) => response.json())
      .then((result) => {
        setLandingPages(result);

      })
      .catch((error) => console.error("Error:", error));
  }, []);

  console.log(landingPages)




  return (
    <div style={{ width: '98%', margin: '5px auto' }}>
      <div>
        <button className='addLandingPage' onClick={handleShow}> <FaPlus />add landing pages</button>

        <section>
          <LandingModal handleClose={handleClose} show={show}></LandingModal>
        </section>
      </div>
      <hr />
      <section >
        <p className='shortlist'>shorted from <button className='shortlistbtn'>Jan,26</button>to <button className='shortlistbtn'>march,26</button></p>
        <div className='landingHeadContainer'>
          <div>
            <p>Total running pages</p>
            <p>{landingPages.length}</p>
          </div>
          <div>
            <p>total running orders</p>
            <p>10</p>
          </div>
          <div>
            <p>total pending orders</p>
            <p>10</p>
          </div>
          <div>
            <p>total revenue</p>
            <p>10</p>
          </div>
        </div>
      </section>
      <section>
        <p className='landingPagetitle'>your landing pages showing below</p>
        <div className='landingNav'>
          <p>Page title</p>
          <p>tags</p>
          <p>category</p>
          <p>Total Order</p>
          <p>page link</p>
          <p>take action</p>
        </div>
      </section>
      {
        landingPages.map((landingPage) => (
          <section>
            <div className='landingData'>
              <p>{landingPage.pageName}</p>
              <p>{landingPage.tags}</p>
              <p>{landingPage.category}</p>
              <p>5</p>

              <p>
                <a href={landingPage.link} target='_blank'>visti web page</a>
              </p>
              <p>Delete</p>
            </div>
          </section>
        ))
      }

    </div>
  );
};

export default LandingPages;